import type { Product, Version } from './types';

export function resolveVersion(product: Product, preferred?: Version | null): Version {
  if (preferred && Number(product[preferred]) > 0) return preferred;
  if (Number(product.fan) > 0) return 'fan';
  if (Number(product.player) > 0) return 'player';
  throw new Error('Esta camiseta no tiene una versión disponible.');
}

export function resolveSize(product: Product, preferred?: string | null): string {
  if (preferred && product.availableSizes.includes(preferred)) return preferred;
  const first = product.availableSizes[0];
  if (!first) throw new Error('Esta camiseta no tiene tallas disponibles.');
  return first;
}
